'use strict';

var premiumBubble = require('../ui/bubble_sidebar_membership');

function updatePriceMemberDisplayPrices(params) {
    const utils = Odigeo.Utils;
    const action = params.action === 'discount' || params.isSubscriptionAdded ? 'login' : params.action;
    const options = params.options;
    const isLogin = action === 'login';
    const isNoDiscount = action === 'noDiscount';
    const ccFeeText = options.membershipCcFee < 0 ? options.membershipCcTextNeg : options.membershipCcTextPos;
    const feeText = isLogin || isNoDiscount ? options.membershipDiscountText : ccFeeText;
    const isPrimeEnabled = Odigeo.Membership.isMembershipProductEnabled && !Odigeo.Utils.isRequestApp('dp') && !Odigeo.SessionScope.isMeta;
    const isSlowLoadingPrimePriceFix = isPrimeEnabled && isNoDiscount;
    const fee = (isLogin || isNoDiscount) && !isSlowLoadingPrimePriceFix ? options.membershipDiscount : options.membershipCcFee;
    const applicableFee = isSlowLoadingPrimePriceFix || !isNoDiscount ? fee : 0;

    displayMembershipPricesNewInfo({
        isLogin: isLogin,
        isNoDiscount: isNoDiscount,
        showPbDisclaimers: params.action !== 'login' && !params.isSubscriptionAdded,
        feeText: feeText,
        disclaimerText: isNoDiscount ? options.membershipDisclaimerDiscountNotApplied : options.membershipDisclaimerDiscountApplied,
        fee: isNoDiscount && Odigeo.SessionScope.mktPortal &&
            Odigeo.History.getPageNameFromFragment() === 'details' ? options.membershipCcFee : applicableFee,
        formattedFee: utils.formatCurrency(+fee, Odigeo._.extend({}, utils.Currency, {negationSymbol: '- '})),
        $cachedSelectors: params.$cachedSelectors,
        $widget: params.$widget,
    });
}

function hasToRenderPremiumBubble() {
    return !Odigeo._.isEqual(Odigeo.Utils.getAppInGlobalScope(), 'dp');
}

function hasToRenderPremiumBubbleFreeTrialRevamp(membershipSettings) {
    const displayIfNotPrimeMember = (!membershipSettings.isMemberLogged || (membershipSettings.isMemberLogged && membershipSettings.isFreeAccount));
    return !Odigeo._.isEqual(Odigeo.Utils.getAppInGlobalScope(), 'dp') &&
        (displayIfNotPrimeMember && Odigeo.History.getPageNameFromFragment() === 'details') ||
        Odigeo.History.getPageNameFromFragment() === 'payment';
}

function renderPremiumBubble(params) {
    var $cachedSelectors = params.$cachedSelectors;
    var options = params.options;
    var membershipSettings = params.membershipSettings;
    var positiveText;
    var formattedPrice;
    let renderedPremiumBubble;
    const {isMembershipProductEnabledDesktop} = Odigeo.Membership;
    const hasToRenderPremiumSideBar = isMembershipProductEnabledDesktop ?
        hasToRenderPremiumBubbleFreeTrialRevamp(membershipSettings) : hasToRenderPremiumBubble();
    if (hasToRenderPremiumSideBar) {
        this.premiumBubbleTmpl = Odigeo._.template($cachedSelectors.premiumBubbleTemplate.html(), params.templateSettings);
        if (!Odigeo._.isUndefined(membershipSettings.membershipPrice)) {
            formattedPrice = Odigeo.Utils.formatCurrency(membershipSettings.membershipPrice);
            positiveText = Odigeo.Utils.replaceCmsKeyArgs(options.translations.premiumBubble.positiveText, formattedPrice);
        }
        const status = premiumBubble.getStatus(membershipSettings, options.page);
        if (status.bubble === 'default') {
            $cachedSelectors.premiumBubbleContent.html('');
        }
        renderedPremiumBubble = this.premiumBubbleTmpl({
            data: {
                status,
                texts: {
                    positiveText: positiveText || '',
                    informativeText: options.translations.premiumBubble.informativeText,
                },
            },
        });
        $cachedSelectors.premiumBubbleContent
            .html(renderedPremiumBubble);
    }
    return renderedPremiumBubble;
}

function displayMembershipPricesNewInfo(obj) {
    var $cachedSelectors = obj.$cachedSelectors;
    $cachedSelectors.membershipPriceDisplayCcFee
        .toggleClass('od-pricebreakdown-membership-discount-fee', obj.isLogin)
        .toggleClass('od-pricebreakdown-membership-discount-fee-warning', obj.isNoDiscount);
    $cachedSelectors.membershipPriceDisplayFeeText.html(obj.feeText);
    $cachedSelectors.membershipPriceDisplayFeeValue.attr('data-fee', obj.fee);
    $cachedSelectors.membershipPriceDisplayFeeValue
        .toggleClass('od-pricebreakdown-membership-discount-fee-slashed', obj.isNoDiscount)
        .html('<span class="odf-icon odf-icon-star odf-icon-left od-pricebreakdown-table-content-infotable-star-color"></span>' + obj.formattedFee);
    $cachedSelectors.membershipPriceDisplayDisclaimerTxt.text(obj.disclaimerText);
    $cachedSelectors.membershipPriceDisplayDisclaimer.toggleClass('odf-hidden', !obj.showPbDisclaimers);
    Odigeo.trigger('getTotalByFullprice', obj.$widget);
}

function updatePromocode(obj) {
    var $promoCodeTable = obj.$cachedSelectors.promocodeContainer;
    var $promoCodeAllPrice;
    var promoCodePrice = Odigeo._.isEmpty(obj.promoCode) ? 0 : obj.promoCode.allPrice;

    $promoCodeTable.toggleClass('odf-hidden', promoCodePrice === 0);
    $promoCodeAllPrice = $promoCodeTable.find('.od-js-all-price');
    $promoCodeAllPrice.html(Odigeo.Utils.formatCurrency(promoCodePrice));
    $promoCodeAllPrice.attr('data-all-price-promocode', promoCodePrice);
    Odigeo.trigger('getTotalByFullprice', obj.$widget);
}

module.exports = {
    renderPremiumBubble: renderPremiumBubble,
    updatePriceMemberDisplayPrices: updatePriceMemberDisplayPrices,
    updatePromocode: updatePromocode,
};

